/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".delete-actions[_ngcontent-%COMP%]{margin-top:10px;flex:1}.delete-actions[_ngcontent-%COMP%]   .btn-secondary[_ngcontent-%COMP%]{color:#df0021;background-image:linear-gradient(to right,#df0021 0,#df0021 66.66667%,transparent 66.66667%)}.delete-actions[_ngcontent-%COMP%]   .btn-secondary[_ngcontent-%COMP%]:focus, .delete-actions[_ngcontent-%COMP%]   .btn-secondary[_ngcontent-%COMP%]:hover{background:0 0}"];
export { styles as styles };
